module.exports = __webpack_public_path__ + "920349d2e9daa8fdb65d6636aa78c4e0.png";